export default "__VITE_ASSET__C9pdsf0S__"